import axios from "axios";
const login = async (email, password) => {
  const response = await axios.post(
    `${process.env.REACT_APP_BACKEND_BASE_URL}/auth/login`,
    { email, password },
    { headers: { "Content-Type": "application/json" } }
  );
  return response.data;
};
const loginMember = async (email, password) => {
  const response = await axios.post(
    `${process.env.REACT_APP_BACKEND_BASE_URL}/auth/memberships/login`,
    { email, password },
    { headers: { "Content-Type": "application/json" } }
  );
  return response.data;
};
const logout = async () => {
  const response = await axios.delete(
    `${process.env.REACT_APP_BACKEND_BASE_URL}/auth/logout`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${window.localStorage.getItem("token")}`,
      },
    }
  );
  if (response.status === 401) {
    window.location.replace("/");
    return null;
  } else {
    return response;
  }
};

const getSearchMember = async (key) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_BASE_URL}/search/cert-of-origin?key=${key}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${window.localStorage.getItem("token")}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.replace("/");
      return null;
    }
  }
};
const registerCOO = async (data) => {
  try {
    console.log("res", data);
    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_BASE_URL}/memberships/cert-of-origin`,
      data,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${window.localStorage.getItem("token")}`,
        },
      }
    );

    return response;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.replace("/");
      return error;
    }
  }
};
const verifyRazorpayPayment = async (paymentData) => {
  try {
    console.log("Verifying payment:", paymentData);
    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_BASE_URL}/memberships/verify-razorpay-payment`,
      paymentData,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${window.localStorage.getItem("token")}`,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Payment verification error:", error);
    if (error.response?.status === 401) {
      window.location.replace("/");
    }
    throw error;
  }
};

const addBalance = async (data) => {
  try {
    console.log("res", data);
    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_BASE_URL}/memberships/coo-accounts-addBalance`,
      data,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${window.localStorage.getItem("token")}`,
        },
      }
    );

    return response;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.replace("/");
      return error;
    }
  }
};
const getCOOReceipts = async (url) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_BASE_URL}/memberships/cert-of-origin/receipts?${url}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${window.localStorage.getItem("token")}`,
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.replace("/");
      return null;
    }
  }
};
const getAllCooReceipts = async (params = {}) => {
  try {
    // Build query string from parameters
    const queryParams = new URLSearchParams();

    // Add required parameters with defaults
    queryParams.append('pageNumber', Number(params.pageNumber) || 0);
    queryParams.append('pageSize', Number(params.pageSize) || 50);

    // Add optional parameters only if they exist
    if (params.startDate) queryParams.append('startDate', params.startDate);
    if (params.endDate) queryParams.append('endDate', params.endDate);
    if (params.status) queryParams.append('status', params.status);
    if (params.companyName) queryParams.append('companyName', params.companyName);
    if (params.receiptNo) queryParams.append('receiptNo', params.receiptNo);
    if (params.cooType) queryParams.append('cooType', params.cooType);

    console.log("API call with query string:", queryParams.toString());

    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_BASE_URL}/memberships/cert-of-origin/AllReceipts?${queryParams.toString()}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${window.localStorage.getItem("token")}`,
        },
      }
    );
    return response;
  } catch (error) {
    console.error("API Error:", error);
    if (error.response?.status === 401) {
      window.location.replace("/");
      return null;
    }
    throw error; // Re-throw the error so it can be caught in fetchData
  }
};
const getMembershipReceipt = async (params = {}) => {
  try {
    const queryParams = new URLSearchParams();
    queryParams.append('pageNumber', params.pageNumber || 1);
    queryParams.append('pageSize', params.pageSize || 10);
    const optionalParams = [
      'startDate', 'endDate', 'status', 'companyName', 'receiptNo',
      'membershipCategory', 'paymentType', 'cancelStatus', 'invoiceType',
      'memberCategory', 'financialYear', 'memberIdStart', 'memberIdEnd',
      'admissionStart', 'admissionEnd', 'sortType', 'dataType'
    ];
    optionalParams.forEach(param => {
      if (params[param]) queryParams.append(param, params[param]);
    });

    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_BASE_URL}/memberships/all/Receipts?${queryParams.toString()}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${window.localStorage.getItem("token")}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("API Error:", error);
    if (error.response?.status === 401) {
      window.location.replace("/");
      return null;
    }
    throw error;
  }
};
const cancelReceipt = async (id) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_BASE_URL}/memberships/${id}/cooReceipt`, {},
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${window.localStorage.getItem("token")}`,
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 401) {
      window.location.replace("/");
      return null;
    }
  }
};
export {
  login,
  loginMember,
  logout,
  registerCOO,
  getCOOReceipts,
  getSearchMember,
  addBalance,
  getAllCooReceipts,
  cancelReceipt,
  verifyRazorpayPayment,
  getMembershipReceipt
};
